<template>
  <d-modal
    class="patients-form-decisions"
    style="background-color: rgba(0,0,0,0.6)!important;">
    <button
      @click.prevent="onClosePopup"
      :class="['mr-1', 'decisions-close-button', show ? 'decisions-close-button-load' : 'decisions-close-button-hidden']">
      <i class="material-icons">close</i>
    </button>
    <d-modal-header>
      <d-modal-title>
        <h3 class="page-title">
          <template v-if="isEdit">Edycja diagnozy</template>
          <template v-else>Dodawanie diagnozy</template>
        </h3>
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <validation-observer ref="patients-form-diagnosis" tag="form">
        <div
          v-for="(diagnosisField, diagnosisFieldIndex) in diagnosisTemplate"
          :key="'diagnosis-field' + diagnosisFieldIndex">
          <div
            v-if="diagnosisField.type === 'input'"
            class="form-group decision-box">
            <label
              :for="diagnosisField.name"
              class="title-box">
              {{ diagnosisField.label }}
            </label>
            <validation-provider
              :name="diagnosisField.name"
              v-slot="{ errors }">
              <d-input
                :type="'text'"
                :state="errors.length ? 'invalid' : null"
                v-model="diagnosisField.value" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
            <p
              v-if="diagnosisField.text"
              class="decision-note">
              {{ diagnosisField.text }}
            </p>
          </div>
          <div
            v-if="diagnosisField.type === 'date'"
            class="form-group decision-box">
            <label
              :for="diagnosisField.name"
              class="title-box">
              {{ diagnosisField.label }}
            </label>
            <validation-provider
              :name="diagnosisField.name"
              v-slot="{ errors }">
              <date-picker
               v-model="diagnosisField.value"
                valueType="format"
                class="mr-2"
                style="width: 100%" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
            <p
              v-if="diagnosisField.text"
              class="decision-note">
              {{ diagnosisField.text }}
            </p>
          </div>
          <div
            v-if="diagnosisField.type === 'textarea'"
            class="form-group decision-box">
            <label
              :for="diagnosisField.name"
              class="title-box">
              {{ diagnosisField.label }}
            </label>
            <validation-provider
              :name="diagnosisField.name"
              v-slot="{ errors }">
              <div :class="{ 'form-control': true, 'is-select': true }">
                <textarea
                  :type="'text'"
                  :state="errors.length ? 'invalid' : null"
                  v-model="diagnosisField.value"
                ></textarea>
              </div>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
            <p
              v-if="diagnosisField.text"
              class="decision-note">
              {{ diagnosisField.text }}
            </p>
          </div>
          <div
            v-if="(diagnosisField.type === 'select') && (diagnosisField.multiselect === 0)"
            class="form-group decision-box">
            <validation-provider
              :name="diagnosisField.name"
              v-slot="{ errors }">
              <label
                :for="diagnosisField.name"
                class="title-box">
                {{ diagnosisField.label }}
              </label>
              <div :class="{ 'form-control': true, 'is-select': true }">
                <v-select
                  :options="diagnosisField.possibleValues"
                  v-model="diagnosisField.value"
                  :reduce="boss => boss.id"
                  label="id">
                  <template slot="option" slot-scope="option">
                    <div class="d-center">
                      {{ option.name }}
                    </div>
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    <div class="selected d-center">
                      {{ option.name }}
                    </div>
                  </template>
                </v-select>
              </div>
              <p
                v-if="diagnosisField.text"
                class="decision-note">
                {{ diagnosisField.text }}
              </p>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
          <div
            v-if="(diagnosisField.type === 'select') && (diagnosisField.multiselect === 1) && (diagnosisField.specializations === true)"
            class="form-group decision-box">
            <validation-provider
              :name="diagnosisField.name"
              v-slot="{ errors }">
              <label class="title-box" :for="diagnosisField.name">{{diagnosisField.label}}</label>
              <multi-select
                :multiple="true"
                :ref="'multi-user-list'"
                placeholder="Wybierz..."
                :options="diagnosisField.possibleValues"
                @input="getValueFromMultiSelect(diagnosisField.value)"
                v-model="diagnosisField.value"
                :track-by="'id'"
                label="name"
                select-label="Wybierz"
                deselectLabel="Usuń wybór"
                selectedLabel="Wybrane"
                :taggable="true" />
              <p
                v-if="diagnosisField.text"
                class="decision-note">
                {{ diagnosisField.text }}
              </p>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
            <div class="form-group" style="display: none">
              <pre>{{ usersList }}</pre>
              <pre>{{ data.specialization }}</pre>
              <pre>{{ specialization }}</pre>
            </div>
            <div
              v-if="usersList.length && diagnosisField.specializations === true"
              :key="userKey"
              class="form-group under-box">
              <label
                :for="diagnosisField.name"
                class="title-box">
                Specjalizacje zespołu
              </label>
              <div
                v-for="(user, index) in usersList"
                :key="index"
                class="form-group">
                <span>
                  <i class="material-icons text-success mr-2">chevron_right</i>
                  <label for="name" class="mr-4 mt-1">
                    {{ user.name }}
                  </label>
                  <validation-provider
                    rules="required"
                    :name="'specializations'"
                    v-slot="{ errors }">
                    <div :class="{ 'form-control': true, 'is-select': true }">
                      <v-select
                        :options="specializationsList"
                        @input="pushIdAndSpecialization(user.id, data.specialization[index], index)"
                        :reduce="boss => boss.id"
                        v-model="data.specialization[index]"
                        label="id">
                        <template slot="option" slot-scope="option">
                          <div class="d-center">
                            {{ option.name }}
                          </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                          <div class="selected d-center">
                            {{ option.name }}
                          </div>
                        </template>
                      </v-select>
                    </div>
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </validation-provider>
                </span>
              </div>
            </div>
          </div>
          <div
            v-if="(diagnosisField.type === 'select') && (diagnosisField.multiselect === 1) && (diagnosisField.specializations === false)"
            class="form-group decision-box">
            <validation-provider
              :name="diagnosisField.name"
              v-slot="{ errors }">
              <label
                :for="diagnosisField.name"
                class="title-box">
                {{ diagnosisField.label }}
              </label>
              <multi-select
                :multiple="true"
                placeholder="Wybierz..."
                :options="diagnosisField.possibleValues"
                v-model="diagnosisField.value"
                :track-by="'id'"
                label="name"
                select-label="Wybierz"
                deselectLabel="Usuń wybór"
                selectedLabel="Wybrane"
                :taggable="true" />
              <p
                v-if="diagnosisField.text"
                class="decision-note">
                {{ diagnosisField.text }}
              </p>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
          <div
            v-if="diagnosisField.type === 'checkbox'"
            class="form-group decision-box">
            <d-checkbox
              :value="'1'"
              :unchecked-value="'0'"
              v-model="diagnosisField.value"
              :class="'mb-3'"
              toggle>
              <span class="title-box">
                {{ diagnosisField.label }}
              </span>
            </d-checkbox>
            <p
              v-if="diagnosisField.text"
              class="decision-note">
              {{ diagnosisField.text }}
            </p>
          </div>
        </div>
        <div class="popup-box-buttons">
          <d-button
            theme="success"
            class="text-nowrap"
            @click.prevent="validateForm">
            Potwierdź
          </d-button>
          <d-button
            theme="secondary"
            class="text-nowrap ml-3"
            @click.prevent="onClosePopup">
            Anuluj
          </d-button>
        </div>
      </validation-observer>
      <div
        v-if="isEdit && !currentDiagnosisLoaded"
        class="pb-3 pt-3 text-center overlay-loading">
        Trwa ładowanie danych&hellip;
      </div>
    </d-modal-body>
  </d-modal>
</template>

<script>
import Vue from 'vue';
import FilterSelect from '@/components/others/FilterSelect';
import DatePicker from 'vue2-datepicker';
import multiSelect from 'vue-multiselect'
import FormUtils from '@/utils/FormUtils.js';

export default {
  name: 'patients-form-diagnosis-popup',
  components: { FilterSelect, DatePicker, multiSelect },
  props: {
    diagnosisId: {
      default: 0,
      type: Number
    },
    onClosePopup: {
      default: () => {},
      type: Function
    },
    onSubmitCallback: {
      default: () => {},
      type: Function
    },
    patientId: {
      required: true,
      type: Number
    },
    show: {
      default: false,
      type: Boolean
    },
    visitId: {
      default: 0,
      type: Number
    }
  },
  computed: {
    isEdit () {
      return !!this.diagnosisId;
    },
    diagnosisTemplate () {
      if (!this.isEdit) {
        return this.$store.getters.getPatientsDiagnosisData;
      }

      if (this.currentDiagnosisLoaded) {
        return this.currentDiagnosis.data_fields;
      }

      return {};
    },
    specializationsList () {
      if (!this.isEdit) {
        return this.$store.getters.getPatientsSpecializationDiagnosisData;
      }

      if (this.currentDiagnosisLoaded) {
        return this.currentDiagnosis.specializations;
      }

      return [];
    }
  },
  data () {
    return {
      currentDiagnosis: {},
      currentDiagnosisLoaded: false,
      data: {
        id: '',
        data_fields: [],
        name: '',
        patient_id: '',
        specialization: []
      },
      specialization: [],
      userKey: 0,
      usersList: []
    };
  },
  mounted () {
    Vue.nextTick(() => {
      if (this.isEdit) {
        this.getDiagnosisItem();
        return;
      }
      this.patientsDiagnosisGet();
    })
  },
  methods: {
    getDiagnosisItem () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/patients/result-diagnosis/item/' + this.diagnosisId,
        outputKey: 'currentDiagnosis',
        loadedKey: 'currentDiagnosisLoaded',
        params: {
          pagination: false
        },
        successAction: () => {
          setTimeout(() => {
            this.data.patient_id = this.currentDiagnosis.patient_id;
            this.data.id = this.currentDiagnosis.id;
            this.specialization = this.currentDiagnosis.specialization;
            this.getValueFromMultiSelectEdit()
          }, 200)
        }
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['patients-form-diagnosis'], this.submitForm);
    },
    submitForm  () {
      let imageFields = false;
      let formDataToSend = {
        patient_id: this.patientId,
        data_fields: this.diagnosisTemplate,
        specialization: this.specialization,
        id: this.data.id,
        visit_id: this.visitId
      };
      let endpointUrl = this.isEdit ? '/patients/result-diagnosis/update/' + this.diagnosisId : '/patients/result-diagnosis/store';
      FormUtils.submit(this, {
        $http: this.$http,
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano diagnozę',
        successText: 'Wybrana diagnoza została zapisana',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacje diagnozy nie powiodły się. Spróbuj ponownie.',
        successAction: () => {
          this.onSubmitCallback();
          this.onClosePopup();
        }
      }, imageFields);
    },
    patientsDiagnosisGet () {
      this.$store.dispatch('patientsDiagnosisGet');
    },
    getValueFromMultiSelect(value) {
      this.usersList = value;
    },
    getValueFromMultiSelectEdit() {
      setTimeout(() => {
        for (let i = 0; i < this.specialization.length; i++) {
          if (this.$refs['multi-user-list'][i]) {
            if (this.$refs['multi-user-list'][i].internalValue.length) {
              const refValue = this.$refs['multi-user-list'][i].internalValue;
              for (let j = 0; j < refValue.length; j++) {
                this.usersList[j] = {
                  id: refValue[j].id,
                  name: refValue[j].name
                };
                this.data.specialization.push(refValue[j].specialization);
              }
            }
          }
        }
        this.userKey += 1;
      }, 500);
    },
    pushIdAndSpecialization(value, special, index) {
      this.specialization[index] = {
        id: value,
        specialization: special
      }
    },
    setImage(event) {
      this.data.scan_file = event.target.files[0];
    },
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
  @import '@/assets/scss/patients-form-decisions.scss';
 </style>
